import SelectorView from 'app/views/selector_view';

export default SelectorView.extend({
  initialize({ dependentSelection }) {
    this.dependentSelection = dependentSelection;
    this.listenTo(this.dependentSelection, 'change', this.render);
    this.listenTo(this.model, 'change', this.render);
  },

  context() {
    return {
      label: this.model.label,
      choices: this.model.getDynamicSelectionChoices(),
      currentChoice: this.model.get('currentChoice'),
    };
  },
});



// WEBPACK FOOTER //
// ./app/views/dynamic_selector_view.js